import log from "loglevel";
import { apiRootEndpoint } from "settings";
import * as t from "./types";
import { processServiceResponse } from "lib/request";

export const getAlertsService = (request: t.GetAlertsRequestType) => {
  log.info("getAlertsService Request: " + JSON.stringify(request));
  let GET_ALERTS_API_ENDPOINT = `${apiRootEndpoint}/alert/system/all/`;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("user_session")}`,
    },
  };

  return fetch(GET_ALERTS_API_ENDPOINT, parameters)
    .then((response) => {
      return processServiceResponse(response, GET_ALERTS_API_ENDPOINT);
    })
    .then((json) => {
      return json;
    });
};
